export default __webpack_public_path__ + "static/media/inspirational, professional.c11739cd.jpeg";